module.exports = __webpack_public_path__ + "img/list_arrow_white.faa12304.svg";